import { IMAGES } from "../lib/site";

export const TICKER_ITEMS = [
  "CIRCUIT BREAKERS",
  "THHN WIRE",
  "BUS PLUGS",
  "SWITCHGEAR",
  "TRANSFORMERS",
  "MCC BUCKETS",
  "PANELBOARDS",
  "DISCONNECTS",
  "COPPER CABLE",
  "COMPLETE WAREHOUSE BUYOUTS",
];

export const WIRE_LIST = [
  "THHN and THWN Copper Wire",
  "XHHW and XHHW-2 Cable",
  "2/0, 3/0, and 4/0 Copper Wire",
  "250 MCM, 350 MCM, 500 MCM, 600 MCM, 750 MCM Cable",
  "Industrial Copper Power Cable",
  "Electrical Wire Reels",
  "Leftover Electrical Contractor Wire",
  "New and Partial Wire Spools",
  "Romex / NM-B Cable",
  "SOOW Flexible Power Cable",
  "Copper and Aluminum Conductors",
  "Service Entrance Cable",
  "Insulated Scrap Copper Wire",
  "Heavy-Duty Industrial Cable",
  "Commercial Building Wire",
  "Factory and Industrial Surplus Cable",
  "Underground and Direct-Burial Cable",
  "Contractor Jobsite Leftovers",
];

export const SERVICES = [
  "CASH PAID FOR ELECTRICAL SURPLUS",
  "NATIONWIDE PURCHASING — ALL 50 STATES",
  "WE COME TO YOU",
  "TOP DOLLAR FOR REUSABLE ELECTRICAL WIRE",
  "FREE SURPLUS EQUIPMENT EVALUATIONS",
  "SAME-DAY OFFERS WHEN POSSIBLE",
  "NO SORTING NECESSARY",
  "COMPLETE WAREHOUSE BUYOUTS",
  "ELECTRICAL CONTRACTOR INVENTORY LIQUIDATIONS",
  "DEMOLITION PROJECT ELECTRICAL RECOVERY",
  "WE ARRANGE FREIGHT, LOADING AND TRUCKING",
  "PAYMENT BEFORE EQUIPMENT IS LOADED, WHEN AGREED",
];

export const WHY_SELL = [
  {
    icon: "DollarSign",
    title: "Competitive Purchasing Offers",
    text: "We evaluate equipment based on condition, quantity, market demand, and potential reuse value.",
  },
  {
    icon: "MapPinned",
    title: "Nationwide Purchasing",
    text: "Based in Michigan, purchasing surplus electrical equipment throughout the United States.",
  },
  {
    icon: "Boxes",
    title: "Large Quantity Purchasing",
    text: "We purchase individual lots and complete industrial electrical inventories.",
  },
  {
    icon: "Truck",
    title: "Freight & Logistics",
    text: "We can coordinate trucking and material removal for qualifying purchases.",
  },
  {
    icon: "Handshake",
    title: "Simple Transactions",
    text: "Send pictures, receive an offer, and arrange the transaction.",
  },
  {
    icon: "Recycle",
    title: "Equipment Recovery & Reuse",
    text: "We prioritize identifying electrical equipment and materials that may have value beyond their scrap content.",
  },
];

export const EQUIPMENT_GRID = [
  {
    title: "Circuit Breakers",
    img: IMAGES.breakers,
    desc: "Molded-case, insulated-case and power circuit breakers — Square D, Siemens, Eaton, Cutler-Hammer, GE, ABB, Westinghouse, Federal Pacific and more.",
    link: "/circuit-breakers",
    category: "Circuit Breakers",
  },
  {
    title: "Bus Plugs & Busway",
    img: IMAGES.busPlugs,
    desc: "Square D I-Line, Siemens and Eaton bus plugs, fusible and breaker bus plugs, bus duct, industrial busway and accessories.",
    link: "/bus-plugs-disconnects",
    category: "Bus Plugs & Busway",
  },
  {
    title: "Electrical Disconnect Switches",
    img: IMAGES.disconnects,
    desc: "Fusible and non-fusible disconnects, heavy-duty safety switches and industrial disconnect equipment.",
    link: "/bus-plugs-disconnects",
    category: "Disconnect Switches",
  },
  {
    title: "Switchgear & Switchboards",
    img: IMAGES.switchgear,
    desc: "Low-voltage and medium-voltage switchgear, switchboards and complete power distribution systems.",
    link: "/transformers-switchgear",
    category: "Switchgear & Switchboards",
  },
  {
    title: "Transformers",
    img: IMAGES.transformers,
    desc: "Dry-type, pad-mounted, distribution and industrial power transformers — step-up and step-down.",
    link: "/transformers-switchgear",
    category: "Transformers",
  },
  {
    title: "Motor Control Centers & MCC Buckets",
    img: IMAGES.mcc,
    desc: "Allen-Bradley MCC buckets, Siemens, Eaton and Square D motor control centers, motor starters and industrial motor controls.",
    link: null,
    category: "Motor Control Centers",
  },
  {
    title: "Electrical Panelboards",
    img: IMAGES.panelboards,
    desc: "Square D, Siemens and Eaton panelboards, distribution panels, breaker interiors and commercial electrical panels.",
    link: null,
    category: "Panelboards",
  },
  {
    title: "Electrical Wire & Cable",
    img: IMAGES.wireReel,
    desc: "THHN, XHHW, large MCM cable, copper and aluminum conductors, full and partial reels — reusable wire may be worth more than scrap.",
    link: "/electrical-wire-cable",
    category: "Electrical Wire & Cable",
  },
];

export const CATEGORIES = {
  "circuit-breakers": {
    seoTitle: "Sell Circuit Breakers for Cash | Square D, Siemens, Eaton Breaker Buyers",
    seoDesc:
      "Velocity Electrical Surplus buys new, used and obsolete circuit breakers nationwide — Square D, Siemens, Eaton, Cutler-Hammer, GE, ABB and more. Call (586) 718-3404.",
    eyebrow: "WE BUY — NATIONWIDE",
    title: "CIRCUIT BREAKERS",
    image: IMAGES.breakers,
    intro: [
      "Velocity Electrical Surplus purchases molded-case breakers, insulated-case breakers, power circuit breakers, obsolete breakers, and industrial electrical distribution equipment.",
      "From a single pallet of breakers to a complete electrical room buyout, we make competitive cash offers and arrange freight for qualifying purchases.",
    ],
    groups: [
      {
        heading: "Manufacturers We Buy",
        items: [
          "Square D / Schneider Electric",
          "Siemens",
          "Eaton",
          "Cutler-Hammer",
          "Westinghouse",
          "General Electric / GE",
          "ABB",
          "Federal Pacific",
          "Other industrial circuit breaker manufacturers",
        ],
      },
      {
        heading: "Breaker Types We Purchase",
        items: [
          "Molded-case circuit breakers",
          "Insulated-case circuit breakers",
          "Power circuit breakers",
          "Obsolete and discontinued breakers",
          "Industrial electrical distribution equipment",
          "New, used, surplus and obsolete condition",
        ],
      },
    ],
    category: "Circuit Breakers",
  },
  "bus-plugs-disconnects": {
    seoTitle: "Sell Bus Plugs & Disconnect Switches | Nationwide Buyers",
    seoDesc:
      "We buy Square D I-Line bus plugs, Siemens and Eaton bus plugs, bus duct, fusible and non-fusible disconnects and heavy-duty safety switches nationwide. Call (586) 718-3404.",
    eyebrow: "WE BUY — NATIONWIDE",
    title: "BUS PLUGS & DISCONNECTS",
    image: IMAGES.busPlugs,
    intro: [
      "Velocity Electrical Surplus purchases bus plugs, busway systems, and industrial disconnect switches from electrical contractors, facilities, and demolition projects across the United States.",
    ],
    groups: [
      {
        heading: "Bus Plugs & Busway We Purchase",
        items: [
          "Square D I-Line Bus Plugs",
          "Siemens Bus Plugs",
          "Eaton Bus Plugs",
          "Fusible Bus Plugs",
          "Circuit Breaker Bus Plugs",
          "Bus Duct",
          "Industrial Busway",
          "Busway Accessories",
        ],
      },
      {
        heading: "Disconnect Switches We Buy",
        items: [
          "Fusible Disconnects",
          "Non-Fusible Disconnects",
          "Heavy-Duty Safety Switches",
          "Industrial Disconnect Equipment",
        ],
      },
    ],
    category: "Bus Plugs & Disconnects",
  },
  "transformers-switchgear": {
    seoTitle: "Used Transformer & Switchgear Buyers | Sell Industrial Switchgear",
    seoDesc:
      "Velocity Electrical Surplus buys dry-type and pad-mounted transformers, low and medium voltage switchgear, switchboards and power distribution equipment nationwide.",
    eyebrow: "WE BUY — NATIONWIDE",
    title: "TRANSFORMERS & SWITCHGEAR",
    image: IMAGES.transformers,
    intro: [
      "We purchase transformers and switchgear lineups from operating facilities, electrical rooms, warehouses, and demolition sites throughout the United States.",
    ],
    groups: [
      {
        heading: "Transformers We Purchase",
        items: [
          "Dry-Type Transformers",
          "Pad-Mounted Transformers",
          "Distribution Transformers",
          "Industrial Power Transformers",
          "Step-Up and Step-Down Transformers",
        ],
      },
      {
        heading: "Switchgear & Switchboards We Purchase",
        items: [
          "Low-Voltage Switchgear",
          "Medium-Voltage Switchgear",
          "Switchboards",
          "Power Distribution Equipment",
          "Industrial Electrical Distribution Systems",
        ],
      },
    ],
    category: "Transformers & Switchgear",
  },
  "electrical-wire-cable": {
    seoTitle: "Electrical Wire Buyers | Sell Surplus Copper Wire, THHN, MCM Cable",
    seoDesc:
      "Don't scrap reusable wire. We buy THHN, XHHW, 250-750 MCM cable, copper and aluminum conductors, full and partial reels nationwide. Top dollar paid. Call (586) 718-3404.",
    eyebrow: "WE BUY — NATIONWIDE",
    title: "ELECTRICAL WIRE & CABLE",
    image: IMAGES.wireReel,
    intro: [
      "At Velocity Electrical Surplus, we specialize in purchasing scrap, surplus, leftover, and reusable electrical wire and cable.",
      "Many electrical contractors and industrial facilities sell valuable wire for its copper content without considering whether the material has additional value as reusable electrical inventory. We evaluate qualifying material for its potential reuse and resale value — our goal is to help you recover more value from your surplus while reducing unnecessary waste.",
    ],
    groups: [
      {
        heading: "Electrical Wire We Purchase",
        items: WIRE_LIST,
      },
    ],
    note: {
      heading: "STOP SELLING VALUABLE WIRE FOR SCRAP PRICES.",
      text: "Let Velocity Electrical Surplus evaluate it first. We clearly distinguish between wire purchased for scrap recovery and wire suitable for reuse — and we evaluate qualifying material for its potential reuse value before you settle for scrap prices. Not every piece of used cable qualifies for reuse, but you deserve to know what yours is worth before it goes to the scrap yard.",
    },
    category: "Electrical Wire & Cable",
  },
  "industrial-surplus": {
    seoTitle: "Industrial Surplus Buyers | Carbide Scrap, Motors, Metals & Machinery",
    seoDesc:
      "We buy tungsten carbide scrap, high-speed steel, cutting tools, industrial electric motors, copper, brass, aluminum, stainless steel and complete industrial inventories.",
    eyebrow: "WE BUY — NATIONWIDE",
    title: "ADDITIONAL INDUSTRIAL SURPLUS",
    image: IMAGES.scrapCopper,
    intro: [
      "Beyond electrical equipment and wire, Velocity Electrical Surplus purchases a wide range of industrial surplus materials, metals, and machinery.",
    ],
    groups: [
      {
        heading: "Additional Materials We Purchase",
        items: [
          "Tungsten Carbide Scrap",
          "High-Speed Steel Scrap",
          "End Mills and Cutting Tools",
          "Carbide Inserts",
          "Tool Steel",
          "Industrial Electric Motors",
          "Industrial Machinery",
          "Copper Bus Bars",
          "Brass, Copper & Aluminum",
          "Stainless Steel",
          "Specialty Metals",
          "Industrial Maintenance Inventory",
          "Manufacturing Equipment",
          "Warehouse Liquidations",
        ],
      },
    ],
    note: {
      heading: "Electrical equipment and reusable wire remain our primary focus.",
      text: "If your surplus lot contains electrical equipment, breakers, wire or cable alongside other industrial material, we can evaluate the entire inventory in one transaction.",
    },
    category: "Industrial Surplus",
  },
  "warehouse-liquidations": {
    seoTitle: "Electrical Warehouse Liquidation Buyers | Complete Inventory Buyouts",
    seoDesc:
      "Closing a business or clearing a warehouse? Velocity Electrical Surplus purchases complete electrical inventories and industrial surplus lots nationwide. Call (586) 718-3404.",
    eyebrow: "COMPLETE BUYOUTS — NATIONWIDE",
    title: "WAREHOUSE & BUSINESS LIQUIDATIONS",
    image: IMAGES.hero,
    intro: [
      "Closing a business? Clearing a warehouse? Upgrading your facility? Velocity Electrical Surplus purchases complete electrical inventories and industrial surplus lots.",
      "We can evaluate complete inventories of circuit breakers, electrical wire, industrial equipment, and related material. Have a large quantity? Contact our purchasing manager directly.",
    ],
    groups: [
      {
        heading: "We Work With",
        items: [
          "Electrical Contractors",
          "Commercial Electricians",
          "Industrial Facilities",
          "Manufacturing Plants",
          "Demolition Contractors",
          "Warehouses",
          "Maintenance Departments",
          "Businesses Closing or Relocating",
          "Facility Renovation Contractors",
        ],
      },
      {
        heading: "How It Works",
        items: [
          "Send photos or an inventory list",
          "Receive a competitive purchasing offer",
          "We arrange freight, loading and trucking",
          "Payment before equipment is loaded, when agreed",
        ],
      },
    ],
    category: "Warehouse Liquidation",
  },
};

export const FORM_CATEGORIES = [
  "Circuit Breakers",
  "Electrical Wire & Cable",
  "Bus Plugs & Busway",
  "Disconnect Switches",
  "Switchgear & Switchboards",
  "Transformers",
  "Motor Control Centers",
  "Panelboards",
  "Industrial Surplus / Metals",
  "Warehouse Liquidation / Complete Inventory",
  "Other",
];

export const CONDITIONS = ["New", "Used", "Surplus", "Discontinued / Obsolete", "Mixed"];
